/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UnitDto } from './UnitDto';
import {
    UnitDtoFromJSON,
    UnitDtoFromJSONTyped,
    UnitDtoToJSON,
} from './UnitDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfUnitDto
 */
export interface ODataPostProcessedResultsOfUnitDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfUnitDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<UnitDto>}
     * @memberof ODataPostProcessedResultsOfUnitDto
     */
    value?: Array<UnitDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfUnitDto
     */
    $type?: ODataPostProcessedResultsOfUnitDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfUnitDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfUnitDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoUnitDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.UnitDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfUnitDtoTypeEnum = typeof ODataPostProcessedResultsOfUnitDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfUnitDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfUnitDto interface.
 */
export function instanceOfODataPostProcessedResultsOfUnitDto(value?: unknown): value is ODataPostProcessedResultsOfUnitDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfUnitDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfUnitDtoFromJSON(json: any): ODataPostProcessedResultsOfUnitDto {
    return ODataPostProcessedResultsOfUnitDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfUnitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(UnitDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfUnitDtoToJSON(value?: ODataPostProcessedResultsOfUnitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(UnitDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

